// prettier-ignore
export default {
    "100": "Comment",
    "110": "Email",
    "120": "Graphic",
    "140": "Outfolder"
}